module.exports = __webpack_public_path__ + "static/hero-phn-8024f533722135523c8ed4348521ec03.png";